<template>
    <span
        class="text-succesx float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9">
        <i
            class="fa fa-check fa-lg icon-button"
            title="Conferir Prestação"
            @click.stop="confirmarConferir(prestacaoContasFinalLancamento.idPrestacaoContasFinal)"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        convenio: Object,
        prestacaoContasFinalLancamento: Object,
    },

    methods: {
        confirmarConferir(id){
            this.$swal({
                title: 'Conferir',
                html: 'Deseja Conferir a Prestação ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.conferir(id)
                }
            })
        },

        conferir(id){
            this.$store.dispatch('addRequest')
            ConveniosServicos.conferirPrestacaoContasFinal(id)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Lançamento Conferido com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                        this.$emit('ocorreuAlteracao')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
}
</script>
